export default __webpack_public_path__ + "static/media/icon-lockCB.c1add941.svg";